import { useItem } from './hooks/use-context';

export function Pictures() {
  const { sections } = useItem();

  const questions = sections.flatMap((section) => section.questions);

  return (
    <div
      style={{
        backgroundColor: '#FFFFFF',
        padding: '10px',
        marginBottom: '20px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        minHeight: '120px',
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          border: '1px solid #69CC8D',
          borderRadius: '5px',
          backgroundColor: '#E0F4E9',
          padding: '6px',
          minHeight: '24px',
          justifyContent: 'space-between',
          textAlign: 'center',
        }}
      >
        REGISTRO FOTOGRÁFICO
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1rem',
          padding: '1rem',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {questions
          .find(
            (question) =>
              question.question_id === '8bea7725-eb73-4fed-8d7a-9b5d9e05da45',
          )
          ?.answers.map((answer, index) => (
            <div
              key={`${answer.id}-${index}`}
              style={{
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                style={{
                  objectFit: 'contain',
                  width: '100%',
                  height: '100%',
                  maxHeight: '300px',
                }}
                src={`${answer.content || ''}`}
                alt="img"
              />
            </div>
          ))}
      </div>
    </div>
  );
}
